import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';

import { TRADE_ONBOARDING_TYPE_PDP, TRADE_ONBOARDING_TYPE_SB } from './constants';

const query = graphql`
    query fetchTradeOnboardingEligibilityQuery($userId: String!, $buyerId: [String!]) {
        viewer {
            isPdpTradeOnboardingDisabled: isEnabled(key: "disablePdpTradeOnboarding")
            isSbTradeOnboardingDisabled: isEnabled(key: "disableSbTradeOnboarding")
            user(userId: $userId) {
                isVerifiedTrade
                verifiedTradeSubStatus
            }
            transactions(buyerId: $buyerId, first: 1, sort: "checkoutDate desc") {
                edges {
                    node {
                        checkoutDate
                    }
                }
            }
        }
    }
`;

function isOldTransaction(transaction) {
    if (!transaction || !transaction.checkoutDate) {
        return true;
    }

    const millisecondsInSixMonths = 15552000000; // 6 * 30 * 24 * 60 * 60 * 1000;
    const transactionDate = new Date(transaction.checkoutDate);
    return transactionDate.getTime() + millisecondsInSixMonths < Date.now();
}

export const fetchTradeOnboardingEligibility = (() => {
    let queryResult = null;

    const pageTypeEnablerMap = {
        [TRADE_ONBOARDING_TYPE_PDP]: 'isPdpTradeOnboardingDisabled',
        [TRADE_ONBOARDING_TYPE_SB]: 'isSbTradeOnboardingDisabled',
    };

    return function(relayEnvironment, userId, pageType) {
        if (queryResult) {
            return queryResult;
        }

        queryResult = fetchQuery(relayEnvironment, query, {
            buyerId: [userId],
            userId,
        }).then(response => {
            const viewer = get(response, 'viewer');
            const enabler = pageTypeEnablerMap[pageType];

            if (!enabler) {
                return false;
            }

            const isVerifiedTrade = get(viewer, 'user.isVerifiedTrade');
            const isDisabled = get(viewer, enabler);
            const isRecentTradeUser =
                get(viewer, 'user.verifiedTradeSubStatus') === 'VERIFIED_IN_LAST_30_DAYS';

            // in this case, an "inactive user" is one that has not completed a purchase in the past 6 months
            const mostRecentTransaction = get(viewer, 'transactions.edges[0].node');
            const isInactiveUser = isOldTransaction(mostRecentTransaction);

            return !isDisabled && isVerifiedTrade && (isRecentTradeUser || isInactiveUser);
        });

        return queryResult;
    };
})();
